import { FeatureFlagController } from "../featureFlag/FeatureFlagController";
import React from "react";
import { styled } from "@mui/system";

const SettingsBlock = styled("div")({
  //margin: "15px",
  padding: "10px",
  width: "100%",
});

interface FeatureFlagsGroupProps {
  keys: string[];
  prefix?: string;
  features: Record<string, any>;
  defaults?: Record<string, any>;
  handleFeaturesChange: (type: "checked" | "value") => (e) => any;
}

export function FeatureFlagsGroup({
  keys,
  prefix,
  features,
  defaults,
  handleFeaturesChange,
}: FeatureFlagsGroupProps) {
  defaults = defaults || {};
  return (
    <SettingsBlock>
      {keys.map((f) => {
        const v = features[f];
        const isBool = typeof v === "boolean";
        const label = prefix ? f.replace(`${prefix}`, "") : f;
        const boolLabel = isBool ? label : "";
        return (
          <FeatureFlagController
            key={f}
            name={f}
            value={v}
            greyed={v == defaults[f]}
            label={isBool ? boolLabel : label}
            handleFeaturesChange={handleFeaturesChange}
          />
        );
      })}
    </SettingsBlock>
  );
}
